// extracted by mini-css-extract-plugin
export default {"uploadContainer":"FileUpload_uploadContainer__uFx7s","focused":"FileUpload_focused__cO3JO","progressBar":"FileUpload_progressBar__S7kyr","deleteIcon":"FileUpload_deleteIcon__A-8Mt"};